// this file is used to simulate a fetch request
// it takes in a wait time in seconds and returns a promise that resolves after that time
// if no wait time is provided, it will randomly wait between 1 and 10 seconds

import { FetchResult } from '@apollo/client'

const simulateFetch = (waitTime?: number): Promise<FetchResult> =>
  new Promise((r) => setTimeout(r, Math.max(1, waitTime ?? Math.floor(Math.random() * 10) + 1) * 1000))
export default simulateFetch
